export type FooterLink = { name: string; href: string };
export type FooterLinkGroup = { heading: string; items: FooterLink[] };

export const FOOTER_LEGAL_LINKS: FooterLink[] = [
  { name: "Privacy", href: "/privacy" },
  { name: "Terms", href: "/terms" },
  { name: "Cookies", href: "/cookies" },
  { name: "Guidelines", href: "/community-guidelines" },
  { name: "Advertising Policy", href: "/advertising-policy" },
];

export function getFooterLinkGroups(opts: {
  hideStudyGroups?: boolean;
  jobBoardEnabled?: boolean;
  hasOpenJobs?: boolean;
}): FooterLinkGroup[] {
  const {
    hideStudyGroups = false,
    jobBoardEnabled = false,
    hasOpenJobs = false,
  } = opts;

  return [
    {
      heading: "Community",
      items: [
        { name: "Certifications", href: "/certifications" },
        ...(!hideStudyGroups
          ? [{ name: "Study Groups", href: "/study-groups" }]
          : []),
        { name: "Forums", href: "/forums" },
        { name: "Tutors", href: "/tutors" },
        ...(jobBoardEnabled ? [{ name: "Job Board", href: "/job-board" }] : []),
      ],
    },
    {
      heading: "Resources",
      items: [
        { name: "Free Study Planner", href: "/free-study-planner" },
        { name: "Blog", href: "/resources" },
      ],
    },
    {
      heading: "Support",
      items: [
        { name: "Help Center", href: "/help" },
        { name: "FAQ", href: "/faq" },
        { name: "Submit a Ticket", href: "/support" },
      ],
    },
    {
      heading: "Company",
      items: [
        { name: "About", href: "/about" },
        { name: "Become a Tutor", href: "/tutor/apply" },
        { name: "Advertise", href: "/advertise" },
        { name: "Contact", href: "/contact" },
        ...(hasOpenJobs ? [{ name: "Careers", href: "/careers" }] : []),
      ],
    },
  ];
}
